import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  TelegramIcon,
} from 'react-share';

// Page-specific engaging share content
const getShareContent = (pathname) => {
  const path = pathname.replace(/^\//, '').replace(/\/$/, '');
  
  const shareMap = {
    '': { 
      title: '🙏 Ahobilam.com - வைதீகம் | பஞ்சாங்கம் | ஜோதிடம்',
      desc: 'அனைத்து வைதீக தகவல்கள், பஞ்சாங்கம், ஜாதகம், திருமண பொருத்தம் ஒரே இடத்தில்! இலவசமாக பயன்படுத்துங்கள்.'
    },
    'panchangam/panchangam': {
      title: '📅 இன்றைய பஞ்சாங்கம் - Live Panchangam',
      desc: 'இன்றைய திதி, நட்சத்திரம், யோகம், கரணம், ராகு காலம், எமகண்டம் - அனைத்தும் ஒரே பார்வையில்! 🕐'
    },
    'panchangam/calendar': {
      title: '🔍 நட்சத்திரம் / திதி தேடல் - Star & Thithi Finder',
      desc: 'எந்த தேதிக்கும் நட்சத்திரம், திதி, யோகம் உடனடியாக கண்டுபிடியுங்கள்! பஞ்சாங்க Calendar.'
    },
    'panchangam/monthly': {
      title: '📆 மாத பஞ்சாங்கம் - Monthly Panchangam',
      desc: 'ஒரு மாதத்தின் முழு பஞ்சாங்கமும் ஒரே பக்கத்தில்! திதி, நட்சத்திரம், சுப நாட்கள் எல்லாம்.'
    },
    'panchangam/horai': {
      title: '⏰ ஹோரை - Planetary Hours Today',
      desc: 'இன்றைய ஹோரை (ஓரை) - எந்த மணிக்கு எந்த கிரகம் ஆதிக்கம்? சுப ஹோரை எப்போது? பாருங்கள்!'
    },
    'panchangam/gowri-panchangam': {
      title: '🌟 கௌரி பஞ்சாங்கம் | வெற்றி | பஞ்ச பக்ஷி',
      desc: 'கௌரி பஞ்சாங்கம், வெற்றி நிர்ணயம், பஞ்ச பக்ஷி - எந்த நேரம் செயல் தொடங்கலாம்? இங்கே பாருங்கள்!'
    },
    'panchangam/casting': {
      title: '🪐 வாக்கிய ஜாதகம் - Vakya Horoscope (PDF)',
      desc: 'பிறந்த நேரம் கொடுத்து வாக்கிய முறையில் ஜாதகம் போடுங்கள்! ராசி, நவாம்சம், தசா-புக்தி அடங்கிய PDF!'
    },
    'panchangam/matching': {
      title: '💍 திருமண பொருத்தம் - Marriage Matching (PDF)',
      desc: '10 பொருத்தங்கள் + ராசி/நட்சத்திர ஆய்வு + PDF! வாக்கிய முறையில் திருமண பொருத்தம் பாருங்கள்.'
    },
    'panchangam/dasabukthi': {
      title: '🔮 தசா புக்தி - Dasa Bukthi Calculator',
      desc: 'உங்கள் நட்சத்திரம் & பிறந்த தேதி கொடுத்து தசா-புக்தி-அந்தரம் கணக்கிடுங்கள்! எந்த தசை நடக்கிறது?'
    },
    'panchangam/good-days': {
      title: '✨ சுப நாட்கள் - Marriage Muhurtham Finder',
      desc: 'திருமண முஹூர்த்த நாட்கள் - லக்ன ஆய்வு, பஞ்சகம், தாரபலம், சுத்தம் அனைத்தும் ஆராய்ந்து சுப நாள் கண்டுபிடிக்கும்!'
    },
    'panchangam/best-for-events': {
      title: '🎯 28 நிகழ்வுகளுக்கு சிறந்த நாட்கள்',
      desc: 'திருமணம், கிரஹப்ரவேசம், நாமகரணம், உபநயனம்... 28 நிகழ்வுகளுக்கு சாஸ்திர படி சிறந்த நாட்கள் கண்டுபிடியுங்கள்!'
    },
    'panchangam/parts-of-panchangam': {
      title: '📖 பஞ்சாங்கத்தின் பாகங்கள் - Complete Guide',
      desc: 'திதி, வாரம், நட்சத்திரம், யோகம், கரணம் - பஞ்சாங்கத்தின் 5 அங்கங்கள் பற்றிய முழு விளக்கம்!'
    },
    'panchangam/allaboutstars': {
      title: '⭐ 27 நட்சத்திரங்கள் - All About Stars',
      desc: '27 நட்சத்திரங்களின் தேவதை, மிருகம், மரம், பக்ஷி, ராஜ்ஜு, நாடி - முழுமையான தகவல்கள்!'
    },
    'panchangam/navagrahas': {
      title: '🪐 நவக்கிரகங்கள் - Navagraha Details',
      desc: 'சூரியன் முதல் கேது வரை - 9 கிரகங்களின் முழு விவரம், ஸ்தோத்திரங்கள், பரிகாரங்கள்!'
    },
    'panchangam/lagnas': {
      title: '🏠 லக்னங்கள் - 12 Lagnas Explained',
      desc: 'மேஷம் முதல் மீனம் வரை - 12 லக்னங்களின் பலன்கள் & குணாதிசயங்கள்!'
    },
    'panchangam/numerology': {
      title: '🔢 எண் கணிதம் - Tamil Numerology',
      desc: 'உங்கள் பெயர் & பிறந்த தேதியின் எண் கணித பலன்கள்! பெயர் சரியா? இங்கே சோதியுங்கள்!'
    },
    'panchangam/day-dhosha': {
      title: '⚠️ 21 நாள் தோஷங்கள் - Daily Doshas',
      desc: 'இன்றைக்கு என்ன தோஷம்? 21 வகை தோஷங்கள் பற்றிய முழு விளக்கம்!'
    },
    'panchangam/dhinaporutham': {
      title: '🤝 தின பொருத்தம் - Daily Star Compatibility',
      desc: 'இன்றைய நட்சத்திரத்திற்கு உங்கள் நட்சத்திரத்தின் பொருத்தம் எப்படி? உடனே பாருங்கள்!'
    },
    'panchangam/gen-sankalpam': {
      title: '🙏 சங்கல்பம் - Sankalpam Generator',
      desc: 'எந்த தேதிக்கும் சரியான சங்கல்ப வாக்கியம் தமிழிலும் சமஸ்கிருதத்திலும் பெறுங்கள்!'
    },
    'panchangam/sankalpam': {
      title: '🙏 தர்ப்பண சங்கல்பம் - Tarpanam Sankalpam',
      desc: 'இன்றைய தர்ப்பணத்திற்கான சங்கல்ப வாக்கியம் - திதி, நட்சத்திரம் எல்லாம் சரியாக!'
    },
    'panchangam/oonams': {
      title: '🍽️ மாசிக / ஊன நாட்கள்',
      desc: 'அடுத்த 30 நாட்களில் வரும் ஊன நாட்கள் - மாசிக ச்ராத்தம் எப்போது? இங்கே பாருங்கள்!'
    },
    'panchangam/full-oonam-list': {
      title: '📋 முழு ஊன பட்டியல் - Complete Oonam List',
      desc: 'வருடம் முழுவதும் அனைத்து ஊன நாட்கள் ஒரே பட்டியலில்! Print செய்து வைத்துக்கொள்ளலாம்.'
    },
    'panchangam/shradhdha-thithi': {
      title: '🪔 ஸ்ராத்த திதி - Shradhdha Dates',
      desc: 'உங்கள் முன்னோர் ஸ்ராத்த திதி எந்த நாளில் வருகிறது? இங்கே கண்டுபிடியுங்கள்!'
    },
    'panchangam/thithi-nirnaya-rules': {
      title: '📜 திதி நிர்ணய விதிகள் - Punyakala Rules',
      desc: 'ஸ்ராத்தம், தர்ப்பணம் எப்போது செய்ய வேண்டும்? திதி நிர்ணய விதிகள் முழு விளக்கம்!'
    },
    'panchangam/gentheetu': {
      title: '👶 ஜனன தீட்டு - Birth Pollution Rules',
      desc: 'குழந்தை பிறந்தால் யாருக்கு எத்தனை நாள் தீட்டு? சாஸ்திர விதிகள் இங்கே!'
    },
    'panchangam/marana-theetu': {
      title: '🕯️ மரண தீட்டு - Death Pollution Calculator',
      desc: 'மரண தீட்டு கணக்கீடு - உறவுமுறை, ஜாதி படி எத்தனை நாள்? இங்கே கணக்கிடுங்கள்.'
    },
    'panchangam/theetu': {
      title: '📏 தீட்டு விதிகள் - Pollution Rules',
      desc: 'ஜனன & மரண தீட்டு பற்றிய முழுமையான சாஸ்திர விதிகள் தொகுப்பு!'
    },
    'panchangam/vivasayam': {
      title: '🌾 விவசாயம் - Agriculture Guide',
      desc: 'நட்சத்திரம், திதி படி விவசாய செயல்கள் - எப்போது விதைக்கலாம்? அறுவடை எப்போது?'
    },
    'panchangam/my-muhurthams': {
      title: '💫 என் முகூர்த்தங்கள் - My Special Muhurthams',
      desc: 'உங்கள் நட்சத்திரத்திற்கான சிறப்பு முகூர்த்த நாட்கள் - திருமணம், கிரஹப்ரவேசம் & மேலும்!'
    },
    'panchangam/all-muhurthams': {
      title: '📅 அனைத்து முகூர்த்தங்கள் - All Muhurthams',
      desc: 'இந்த வருடத்தின் அனைத்து முகூர்த்த நாட்கள் ஒரே இடத்தில்!'
    },
    'panchangam/dayvalue-premium': {
      title: '💎 Day Value Premium - நாள் மதிப்பு',
      desc: 'இன்றைய நாள் எப்படி? உங்கள் நட்சத்திரத்திற்கு விரிவான பலன்கள் & ஆய்வு!'
    },
    'panchangam/premium-calendar': {
      title: '👑 Premium Calendar - சுப நாள் காலண்டர்',
      desc: 'சுப நாட்கள் மட்டும் ஹைலைட் செய்யப்பட்ட சிறப்பு காலண்டர்!'
    },
    'panchangam/about': {
      title: '🙏 Ahobilam.com - எங்களைப் பற்றி',
      desc: 'பாரம்பரிய வாக்கிய பஞ்சாங்கம் அடிப்படையில் அமைந்த முழுமையான வைதீக தளம்!'
    },
    'divyadesams': {
      title: '🛕 108 திவ்ய தேசங்கள் - Divya Desams',
      desc: '108 திவ்ய தேசங்களின் முழு தகவல்கள் - ஸ்தல புராணம், மங்களாசாசனம், வழி!'
    },
    'blog': {
      title: '📝 அனுபவ அறிவு - Articles & Knowledge',
      desc: 'வைதீகம், ஜோதிடம், ஆன்மிகம் பற்றிய சுவாரஸ்யமான கட்டுரைகள்!'
    },
    'shop': {
      title: '🛒 Ahobilam Shop - பூஜை பொருட்கள்',
      desc: 'பூஜை சாமான்கள், புத்தகங்கள், பஞ்சாங்கம் - ஆன்லைனில் வாங்குங்கள்!'
    },
    'vaideekam': {
      title: '📿 வைதீக கர்மாக்கள் - Vedic Rituals',
      desc: 'ஸ்ராத்தம், தர்ப்பணம், ஊன, தீட்டு - அனைத்து வைதீக விஷயங்களும் ஒரே இடத்தில்!'
    },
  };

  // Try exact match first, then partial
  if (shareMap[path]) return shareMap[path];
  
  // Try partial match
  for (const [key, val] of Object.entries(shareMap)) {
    if (key && path.includes(key)) return val;
  }
  
  // Default
  return {
    title: '🙏 Ahobilam.com - வைதீகம் | பஞ்சாங்கம் | ஜோதிடம்',
    desc: 'வாக்கிய பஞ்சாங்கம், ஜாதகம், திருமண பொருத்தம், முகூர்த்தம், சங்கல்பம் - அனைத்தும் இலவசம்! இப்போதே பாருங்கள்.'
  };
};

const FloatingShare = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  
  const shareUrl = `https://ahobilam.com${location.pathname}`;
  const { title, desc } = getShareContent(location.pathname);
  const shareText = `${title}\n\n${desc}\n\n`;

  const handleCopyLink = () => {
    const fullText = `${title}\n\n${desc}\n\n🔗 ${shareUrl}`;
    navigator.clipboard.writeText(fullText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="fixed left-0 top-1/3 z-50 flex flex-col items-start group">
      {/* Main Toggle Button */}
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="bg-orange-600 text-white p-3 rounded-r-xl shadow-lg hover:bg-orange-700 transition-colors flex items-center justify-center"
        title="Share this page"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
      </button>

      {/* Share Options - Slide Out */}
      <div className={`absolute top-0 left-full ml-1 flex flex-col gap-2 p-2 bg-white/95 backdrop-blur-sm rounded-xl shadow-[0_0_15px_rgba(0,0,0,0.15)] border border-gray-100 transition-all duration-300 origin-left ${isOpen ? 'scale-x-100 opacity-100' : 'scale-x-0 opacity-0 pointer-events-none'}`}>
        <WhatsappShareButton url={shareUrl} title={shareText} separator="" onClick={() => setIsOpen(false)}>
          <WhatsappIcon size={40} round className="hover:scale-110 transition-transform shadow-sm" />
        </WhatsappShareButton>

        <FacebookShareButton url={shareUrl} quote={shareText} onClick={() => setIsOpen(false)}>
          <FacebookIcon size={40} round className="hover:scale-110 transition-transform shadow-sm" />
        </FacebookShareButton>

        <TwitterShareButton url={shareUrl} title={`${title} - ${desc}`} onClick={() => setIsOpen(false)}>
          <TwitterIcon size={40} round className="hover:scale-110 transition-transform shadow-sm" />
        </TwitterShareButton>

        <TelegramShareButton url={shareUrl} title={shareText} onClick={() => setIsOpen(false)}>
          <TelegramIcon size={40} round className="hover:scale-110 transition-transform shadow-sm" />
        </TelegramShareButton>

        {/* Copy Link Button */}
        <button onClick={handleCopyLink} title="Copy link with description"
          className="w-10 h-10 rounded-full bg-gray-600 hover:bg-gray-700 text-white flex items-center justify-center hover:scale-110 transition-transform shadow-sm text-sm">
          {copied ? '✓' : '🔗'}
        </button>
      </div>
    </div>
  );
};

export default FloatingShare;